import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c65331aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PDivider = _resolveComponent("PDivider")!
  const _component_WMenuPosition = _resolveComponent("WMenuPosition")!
  const _component_WToastPosition = _resolveComponent("WToastPosition")!
  const _component_WStatusAlertMute = _resolveComponent("WStatusAlertMute")!
  const _component_WStatusAlertSound = _resolveComponent("WStatusAlertSound")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createBlock(_component_PCard, { class: "min-h-screen" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WTitle, { text: "Settings" })
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_PDivider, { class: "mb-2" }),
      _createVNode(_component_WMenuPosition),
      _createVNode(_component_PDivider, { class: "mb-2" }),
      _createVNode(_component_WToastPosition),
      _createVNode(_component_PDivider, { class: "mb-2" }),
      _createElementVNode("div", {
        id: "alert-sound",
        class: _normalizeClass(["settings-anchor", { 'settings-anchor--highlight': _ctx.highlightAlertSound }])
      }, [
        _createVNode(_component_WStatusAlertMute),
        _createVNode(_component_PDivider, { class: "mb-2" }),
        _createVNode(_component_WStatusAlertSound)
      ], 2),
      _createVNode(_component_PDivider, { class: "mb-2" })
    ]),
    _: 1
  }))
}